import { Box, Typography } from '@mui/material'
import data from '../../helpers/DataHelper'
import { useTheme } from '@emotion/react'

export default function TechStack(props) {

  const {
    filterArray
  } = props

  const theme = useTheme()

  return (
    <Box sx={{
      display: "flex",
      gap: 3,
      flexWrap: "wrap",
      justifyContent: "center",
      [theme.breakpoints.down("lg")]: {
        gap: 2,
      },
      [theme.breakpoints.down("md")]: {
        gap: 1,
      },
      img: {
        width: "100%",
        aspectRatio: 1 / 1,
        objectFit: "contain",
      },
      "& .tech-stack-item": {
        display: "flex",
        background: theme.palette.background.paper+"33",
        backdropFilter: "blur(40px)",
        borderRadius: "40px",
        aspectRatio: 1 / 1,
        flex: "0 0 auto",
        p: 2,
        border: `1px solid ${theme.palette.divider}`,
        width: `calc(calc(100% - calc(calc(3 * 8px)*6) ) / 7)`,
        flexShrink: 0,
        transition: "transform 0.2s",
        position: "relative",
        "& .infoName": {
          position: "absolute",
          top: "0px",
          left: "50%",
          transform: "translate(-50%, -50%)",
          p: "8px 16px",
          borderRadius: "23px",
          background: theme.palette.background.paper,
          textAlign: "center",
          opacity: 0,
          transition: "opacity 0.2s",
          border: `1px solid ${theme.palette.divider}`,
          zIndex: 100,
        },
        "&:hover": {
          transform: "scale(1.1)",
          "& .infoName": {
            opacity: 1,
          }
        },
        "&:tap": {
          transform: "scale(1.1)",
          "& .infoName": {
            opacity: 1,
          }
        },
        [theme.breakpoints.down("lg")]: {
          p: 2,
          width: `calc(calc(100% - calc(calc(2 * 8px) * 4) ) / 5)`,
        },
        [theme.breakpoints.down("md")]: {
          p: 1,
          borderRadius: "24px",
          width: `calc(calc(100% - calc(calc(1 * 8px) * 3) ) / 4)`,
        },
        [theme.breakpoints.down("sm")]: {
          width: `calc(calc(100% - calc(calc(1 * 8px) * 2) ) / 3)`,
        },
      }
    }}>
      {
        Object.keys(data.giano.tech_stack).map((key, index) => {
          if (filterArray && !filterArray.includes(key)) {
            return null
          } else {


            const tech = data.giano.tech_stack[key]
            return (


              <Box
                  key={tech.name + "_" + index}
                  className="tech-stack-item"
                >
                  <img src={tech.logo} alt={tech.name} />
                  <Typography className="infoName" variant="body2">{tech.name}</Typography>
                </Box>

            )
          }
        })
      }


    </Box>
  )
}
